import { useEffect, useState, useMemo, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ProfileIcon from "../../../Assets/IconComponents/ProfileIcon";
import RapInfoProfile from "./RapInfoProfile";
import WageRate from "./WageRate";
import WpsActivities from "./WpsActivities";
import RelatedInstructionDescriptions from "./RelatedInstructionDescriptions";
import SelectionProcedures from "./SelectionProcedures";
import RAPDocuments from "./RAPDocuments";
import RapRatio from "./RapRatio";
import { useTheme } from "../../../ContextStore/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout, userSelector } from "../../../store/features/auth/authSlice";
import logo from "../../../Assets/Icons/logo.png";
import logoWhite from "../../../Assets/Icons/logo-white.png";
import menuopen from "../../../Assets/Icons/menu-open.png";
import menuclose from "../../../Assets/Icons/menu-close.png";
import NotificationIcon from "../../../Assets/IconComponents/Notification";
import { headerMenus } from "../../../../utils/MenusConfig";
import HelpMenu from "../../../Components/Header/HelpMenu";
import {Layout, DetailPageLayout} from "@proscore-ai/proscore-ui-library";

export default function RapDetail() {
  const { tab, id } = useParams();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState("");
  const isAddMode = useMemo(() => id === "add", [id]);
  const [rapSubTitle, setRapSubTitle] = useState("");
  const { theme } = useTheme();
    const [menuOpen, setMenuOpen] = useState(false);
    const [popOverOpen, setPopOverOpen] = useState(false);
    const ref = useRef(null);
    const userData = useSelector(userSelector);
    const dispatch = useDispatch();
  
    const handleTabClick = tab => {
      navigate(`${tab.to}`);
    };
    const handleMenuOpen = () => setMenuOpen(!menuOpen);
  
    const onLogout = () => {
      dispatch(handleLogout());
    };
  
    const manageAccount = () => {
      setPopOverOpen(false);
    };
  
    const handleHome = () => {
      navigate("/clients");
    };
  const tabs = isAddMode
    ? [
        {
          to: "/rapinfo",
          title: "RAP Info",
          key: "rapinfo",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        }
      ]
    : [
        {
          to: "/rapinfo",
          title: "RAP Info",
          key: "rapinfo",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        },
        {
          to: "/rap-ratio",
          title: "RAP Ratio",
          key: "rap-ratio",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        },
        {
          to: "/wagerate",
          title: "Wage Rate",
          key: "wagerate",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        },
        {
          to: "/wps-activities",
          title: "WPS Activities",
          key: "wps-activities",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        },
        {
          to: "/related-instruction-descriptions",
          title: "Related Instruction Descriptions",
          key: "related-instruction-descriptions",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        },
        {
          to: "/selection-procedures",
          title: "Selection Procedures",
          key: "selection-procedures",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        },
        {
          to: "/rap-documents",
          title: "RAP Documents",
          key: "rap-documents",
          isActive: false,
          hasArrow: false,
          icon: ProfileIcon
        }
      ];

  const backAction = () => {
    navigate("/rap-info");
  };

  const handleTabInnerClick = tab => {
    navigate(`/rap-info/${id}${tab.to}`);
  };

  const getRapInfoProfileData = async id => {
    setRapSubTitle("");
  };

  useEffect(() => {
    if (!isAddMode) getRapInfoProfileData(id);
  }, [id]);

  useEffect(() => {
    const selectedTab = tabs.find(t => t.key === tab?.toLowerCase())?.title;
    setActiveTab(selectedTab || "RAP Info");
  }, [tab]);

  return (
    <Layout
      theme={theme}
      user={{
        userName: userData?.userName,
        email: userData?.email,
        avatar: userData?.avatar
      }}
      onLogout={onLogout}
      onTabClick={handleTabClick}
      onLogoClick={handleHome}
      logo={logo}
      logoWhite={logoWhite}
      menuOpenIcon={menuopen}
      menuCloseIcon={menuclose}
      menuTabs={headerMenus}
      NotificationIcon={NotificationIcon}
      HelpComponent={HelpMenu}
    >
      {activeTab && (
        <DetailPageLayout
          backAction={backAction}
          tabs={tabs}
          title={isAddMode ? "ADD RAP INFO" : "Registered Apprenticeship Program"}
          subTitle={isAddMode ? "" : rapSubTitle}
          backLabel="Go back to Rap Info"
          activeTab={activeTab}
          handleTabClick={handleTabInnerClick}
        >
          {activeTab === "RAP Info" && <RapInfoProfile />}
          {activeTab === "RAP Ratio" && <RapRatio />}
          {activeTab === "Wage Rate" && <WageRate />}
          {activeTab === "WPS Activities" && <WpsActivities />}
          {activeTab === "Related Instruction Descriptions" && <RelatedInstructionDescriptions />}
          {activeTab === "Selection Procedures" && <SelectionProcedures />}
          {activeTab === "RAP Documents" && <RAPDocuments />}
        </DetailPageLayout>
      )}
    </Layout>
  );
}
